import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./Utils/i18n";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import { CookiesProvider } from "react-cookie";
import TenantDocumentListsState from "./context/tenantDocumentLists/TenantDocumentListsState";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://51b71c972175b7510ab53902affc2433@o4511501269532672.ingest.de.sentry.io/4511501271367760",
  environment:
    process.env.REACT_APP_URL_NAME === "app.skortorent.com"
      ? "production"
      : "development",
  enabled: process.env.REACT_APP_URL_NAME === "app.skortorent.com",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = ReactDOM.createRoot(document.getElementById("root"));
const stripePromise = loadStripe(
  "pk_test_51NicRRSEz5zd53ew3ZsFt9lKrBq4TZhTBx0cYiHP1AZ3VrnPRGQMFHSSEz46dXjsNfJTcjmTJvQzSoAsyb1UmDqz00237bzGSL"
);

// (function patchHistoryForDedupe() {
//   const originalPush = window.history.pushState;
//   const originalReplace = window.history.replaceState;

//   let lastUrl = normalize(
//     window.location.pathname +
//     window.location.search +
//     window.location.hash
//   );

//   function normalize(url) {
//     try {
//       const u = new URL(url, window.location.origin);

//       let pathname = u.pathname.replace(/\/+$/, "") || "/";

//       const params = new URLSearchParams(u.search);
//       const sortedParams = new URLSearchParams();
//       [...params.entries()]
//         .sort(([a], [b]) => a.localeCompare(b))
//         .forEach(([k, v]) => sortedParams.append(k, v));

//       const search = sortedParams.toString();
//       return pathname + (search ? `?${search}` : "") + u.hash;
//     } catch {
//       return url;
//     }
//   }

//   function getCurrent() {
//     return normalize(
//       window.location.pathname +
//         window.location.search +
//         window.location.hash
//     );
//   }

//   function shouldReplace(nextUrl) {
//     return normalize(nextUrl) === getCurrent();
//   }

//   window.history.pushState = function (state, title, url) {
//     if (!url) {
//       return originalPush.apply(this, arguments);
//     }

//     const next = normalize(url);

//     // 🔥 KEY FIX: compare with last pushed, not current location
//     if (next === lastUrl) {
//       return originalReplace.call(this, state, title, url);
//     }

//     lastUrl = next;
//     return originalPush.call(this, state, title, url);
//   };

//   window.history.replaceState = function (state, title, url) {
//     if (url) {
//       lastUrl = normalize(url);
//     }
//     return originalReplace.call(this, state, title, url);
//   };

//   // react router uses window.history.go, so patching it
//   // const originalGo = window.history.go;

//   // window.history.go = function (delta) {
//   //   if (delta === -1) {
//   //     // try skipping duplicate entries
//   //     let steps = -1;

//   //     const current =
//   //       window.location.pathname +
//   //       window.location.search +
//   //       window.location.hash;

//   //     // naive approach: try stepping back more if needed
//   //     const trySkip = () => {
//   //       originalGo.call(window.history, steps);
//   //     };

//   //     trySkip();
//   //   } else {
//   //     return originalGo.call(window.history, delta);
//   //   }
//   // };
// })();

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <I18nextProvider i18n={i18n}>
      <CookiesProvider>
        <Elements stripe={stripePromise}>
          {/* Loads the required-document lists as soon as the app opens */}
          <TenantDocumentListsState>
            <App />
          </TenantDocumentListsState>
        </Elements>
      </CookiesProvider>
    </I18nextProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
